var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.685 5.69998L9.84 1.54498C10.275 1.10248 10.98 1.10248 11.4225 1.53748C11.6925 1.80748 11.805 2.18998 11.73 2.56498L11.0175 5.99998H15.255C16.8675 5.99998 17.955 7.64998 17.325 9.13498L14.88 14.8425C14.64 15.39 14.1 15.75 13.5 15.75H6.75C5.925 15.75 5.25 15.075 5.25 14.25V6.75748C5.25 6.35998 5.4075 5.97748 5.685 5.69998ZM3.75 14.25C3.75 15.075 3.075 15.75 2.25 15.75C1.425 15.75 0.75 15.075 0.75 14.25V8.24998C0.75 7.42498 1.425 6.74998 2.25 6.74998C3.075 6.74998 3.75 7.42498 3.75 8.24998V14.25Z",
    fill: "#044B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.26840fddafe6ec1feda01a0d404007ed.svg";
export { ForwardRef as ReactComponent };